import { Routes } from '@angular/router';
import {BlogEntry1Component} from "./entries/blog-entry-1/blog-entry-1.component";
import {BlogEntry2Component} from "./entries/blog-entry-2/blog-entry-2.component";
import {BlogEntry3Component} from "./entries/blog-entry-3/blog-entry-3.component";
import {BlogEntry4Component} from "./entries/blog-entry-4/blog-entry-4.component";
import {BlogEntry5Component} from "./entries/blog-entry-5/blog-entry-5.component";
import {BlogEntry6Component} from "./entries/blog-entry-6/blog-entry-6.component";
import {BlogEntry7Component} from "./entries/blog-entry-7/blog-entry-7.component";
import {BlogEntry8Component} from "./entries/blog-entry-8/blog-entry-8.component";
import {BlogEntry9Component} from "./entries/blog-entry-9/blog-entry-9.component";
import {BlogEntry10Component} from "./entries/blog-entry-10/blog-entry-10.component";
import {BlogEntry11Component} from "./entries/blog-entry-11/blog-entry-11.component";
import {BlogEntry12Component} from "./entries/blog-entry-12/blog-entry-12.component";
import {BlogEntry13Component} from "./entries/blog-entry-13/blog-entry-13.component";
import {BlogEntry14Component} from "./entries/blog-entry-14/blog-entry-14.component";
import {BlogEntry15Component} from "./entries/blog-entry-15/blog-entry-15.component";
import {BlogEntry16Component} from "./entries/blog-entry-16/blog-entry-16.component";
import {BlogEntry17Component} from "./entries/blog-entry-17/blog-entry-17.component";
import {BlogEntry18Component} from "./entries/blog-entry-18/blog-entry-18.component";



const blogRoute: Routes = [
  {
    path: '1',
    component: BlogEntry1Component,
  },
  {
    path: '2',
    component: BlogEntry2Component,
  },
  {
    path: '3',
    component: BlogEntry3Component,
  },
  {
    path: '4',
    component: BlogEntry4Component,
  },
  {
    path: '5',
    component: BlogEntry5Component,
  },
  {
    path: '6',
    component: BlogEntry6Component,
  },
  {
    path: '7',
    component: BlogEntry7Component,
  },
  {
    path: '8',
    component: BlogEntry8Component,
  },
  {
    path: '9',
    component: BlogEntry9Component,
  },
  {
    path: '10',
    component: BlogEntry10Component,
  },
  {
    path: '11',
    component: BlogEntry11Component,
  },
  {
    path: '12',
    component: BlogEntry12Component,
  },
  {
    path: '13',
    component: BlogEntry13Component,
  },
  {
    path: '14',
    component: BlogEntry14Component,
  },
  {
    path: '15',
    component: BlogEntry15Component,
  },
  {
    path: '16',
    component: BlogEntry16Component,
  },
  {
    path: '17',
    component: BlogEntry17Component,
  },
  {
    path: '18',
    component: BlogEntry18Component,
  },

];

export default blogRoute;
